import {
  Box,
  Button,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Modal,
  Typography,
} from "@mui/material";
import {
  ModalActionButtonStyles,
  ModalBaseStyles,
  ModalHeader,
} from "../../Common/styles/modal";
import { IncompleteScreeningForm } from "../../../utils/screeningEditEligibility";

type Props = {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
  incompleteForms: IncompleteScreeningForm[];
  loading?: boolean;
};

const IncompleteScreeningConfirmModal = ({
  open,
  onClose,
  onContinue,
  incompleteForms,
  loading = false,
}: Props) => {
  const totalMissing = incompleteForms.reduce(
    (sum, f) => sum + f.missingRequiredCount,
    0
  );
  const formCount = incompleteForms.length;
  const questionLabel =
    totalMissing === 1 ? "required question" : "required questions";
  const formLabel = formCount === 1 ? "form" : "forms";

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...ModalBaseStyles, minHeight: "20vh" }}>
        <ModalHeader
          title="Unanswered required questions"
          onCloseClick={onClose}
        />
        <Typography variant="body1" sx={{ mb: 1 }}>
          {totalMissing} {questionLabel} unanswered across {formCount}{" "}
          {formLabel}. Screening will be locked. You can edit later.
        </Typography>
        <List
          dense
          sx={{
            maxHeight: 240,
            overflow: "auto",
            bgcolor: "grey.50",
            borderRadius: 1,
            mb: 1,
          }}
        >
          {incompleteForms.map((form) => (
            <ListItem key={form.formId || form.name} disableGutters sx={{ px: 1.5 }}>
              <ListItemText
                primary={`${form.name} — ${form.missingRequiredCount} required unanswered`}
              />
            </ListItem>
          ))}
        </List>
        <Box sx={{ ...ModalActionButtonStyles, mt: 2 }}>
          {!loading ? (
            <>
              <Button onClick={onClose} variant="outlined">
                Go back
              </Button>
              <Button onClick={onContinue} variant="contained">
                Continue anyway
              </Button>
            </>
          ) : (
            <CircularProgress size={25} />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default IncompleteScreeningConfirmModal;
